import { object, array, func } from 'prop-types'
import { downloadAsset } from '@opallabs/cassini'
import { TitleAndDescription, kuiperClassNames } from '@opallabs/kuiper'
import Attachment from '../Attachment'

import './styles.scss'

const noStory = {
  title: 'NO STORY',
  color: 'default',
}

const BriefAttachment = ({ brief }) => {
  if (brief.file) {
    return (
      <Attachment
        fileName={brief.file}
        fileSize={brief.size}
        description={brief.description}
        onDownload={() => {
          downloadAsset({
            filename: brief.file,
            uuid: brief.uuid,
          })
        }}
        onView={brief.onView}
        title="Brief"
      />
    )
  }

  return null
}

const StoryAndMomentHeader = ({
  brief = {},
  moment,
  navigateTo,
  primaryStory = noStory,
  secondaryStories = [],
}) => (
  <div className={kuiperClassNames('story-moment-header')}>
    <TitleAndDescription
      title="Primary Story"
      descriptionStyle="bright"
      description={primaryStory.title}
      descriptionIcon="story"
      descriptionIconOptions={{
        color: primaryStory.color,
        colorCode: primaryStory.colorCode,
      }}
      navigateTo={() => navigateTo(primaryStory.title)}
      isLinkable={primaryStory.title !== 'NO STORY'}
    />
    <TitleAndDescription
      title="Moment"
      descriptionStyle="bright"
      description={moment.title}
      descriptionIcon="moment"
      descriptionIconOptions={{
        color: moment.color,
        colorCode: moment.colorCode,
      }}
      navigateTo={() => navigateTo('moment')}
      isLinkable={true}
    />
    {secondaryStories.length > 0 && (
      <TitleAndDescription
        className="secondary-stories"
        title="Secondary Stories"
        descriptionStyle="bright"
        list={secondaryStories}
        navigateTo={(val) => navigateTo(val)}
        isLinkable={true}
      />
    )}
    <BriefAttachment brief={brief} />
  </div>
)

StoryAndMomentHeader.propTypes = {
  brief: object,
  moment: object,
  navigateTo: func,
  primaryStory: object,
  secondaryStories: array,
}

export default StoryAndMomentHeader
